module.exports = __webpack_public_path__ + "static/energi-52d829a7ec72ff666d82746188ca0d1f.png";